import React, { FunctionComponent, useContext } from 'react'
import { StateStore } from '../../containers/StoreProvider'
import { logout } from '../../util/login'
import { Button } from '../Button'
import { ButtonColumn, Text } from '../layout'
import { formatMessageSafe } from '../../util/translateInputOptions'
import { defineMessages, useIntl } from 'react-intl'
import styled from 'styled-components'

const LogoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    flex-direction: column;
    align-items: stretch;
  }
`

const messages = defineMessages({
  logout: {
    id: 'containers.logout.logout',
    defaultMessage: 'logout',
  },
})

const Logout: FunctionComponent = () => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  const { state } = useContext(StateStore)

  if (!state || !state.currentUser) {
    return null
  }

  return (
    <LogoutContainer>
      <ButtonColumn>
        <Text size="m">{state.currentUser.username}</Text>
      </ButtonColumn>
      <ButtonColumn mobileMargin="0">
        <Button
          label={formatMessage(messages.logout)}
          category="logout"
          mobileWidth="100%"
          onClick={() => {
            logout()
          }}
        />
      </ButtonColumn>
    </LogoutContainer>
  )
}

export default Logout
